import { fmtMoeda } from "../utils/format";
import { CalcIcon } from "./calculadora/CalcIcon";

export function StoreProductCard({ produto, onOpen, onAdd }) {
  const inStock = produto.estoque > 0;
  const photo = produto.fotoBase64 || produto.fotos?.find(f => f.tipo !== "video")?.url;
  return <article className="store-product">
    <button type="button" className="store-product-open" onClick={onOpen} aria-label={`Ver detalhes de ${produto.nome}`}>
      <div className="store-product-image">{photo ? <img src={photo} alt={produto.nome} loading="lazy" decoding="async" /> : <CalcIcon name="box" size={48} />}</div>
      <h3>{produto.nome}</h3>
    </button>
    <div className="store-product-info">
      <span className={`store-availability${inStock ? " in-stock" : ""}`}><i />{inStock ? "Pronta entrega" : "Sob encomenda"}</span>
      <strong className="store-product-price">{fmtMoeda(produto.preco || 0)}</strong>
      <button type="button" className="store-add" onClick={onAdd} aria-label={`${inStock ? "Adicionar" : "Encomendar"} ${produto.nome}`}><CalcIcon name="plus" size={16} />{inStock ? "Adicionar" : "Encomendar"}</button>
    </div>
  </article>;
}
